import React from 'react'

const Row = ({ data, onEdit, onDelete, isActive, onClick}) => {
    const keys = Object.keys(data)
    return (  
        <tr className={`table-row ${isActive ? "table-row--active" : ''} ${onClick ? "clickable" : ''}`} onClick={onClick} >
            { keys.map(key => <td key={key} ><div className="table-row__data flex-center user-select-all">{data[key]}</div></td>)}
            { onEdit && <td onClick={onEdit}><span className="glyphicon glyphicon-pencil edit-button flex-center" /></td> }
            { onDelete && <td onClick={onDelete}><span className="glyphicon glyphicon-trash delete-button flex-center" /></td> }
        </tr>
    )
}

export default Row